class WishlistSingle {
  static addedProducts = [];

  static init() {
    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(function (swat) {
      swat.fetch(function (products) {
        WishlistSingle.addedProducts = products;
        updateProductCardsWishlist();
      });

      $(document).on('click', '.js-wishlist__add', function (e) {
        e.preventDefault();
        var $this = $(this);
        var product = {
          empi: +$this.attr('data-empi'),
          epi: +$this.attr('data-epi'),
          du: $this.attr('data-du'),
          qty: 1,
          cprops: {
            handle: $this.attr('data-handle'),
          },
        };

        var successCallBack = function (success) {
          console.log({ success });
          // updateProductCardsWishlist();
        };

        var failureCallBack = function (failure) {
          console.log({ failure });
          // updateProductCardsWishlist();
          if (!$('body').hasClass('customer--logged-in')) {
            window.location.href = '/account/login';
          }
        };

        if ($(this).hasClass('active')) {
          swat.removeFromWishList(
            product,
            function () {
              WishlistSingle.addedProducts = WishlistSingle.addedProducts.filter(
                (item) => item?.epi != product?.epi
              );
              updateProductCardsWishlist();
            },
            failureCallBack
          );
        } else {
          swat.addToWishList(
            product,
            function () {
              WishlistSingle.addedProducts = [...WishlistSingle.addedProducts, product];
              updateProductCardsWishlist();
              if (!$('body').hasClass('customer--logged-in')) {
                window.location.href = '/account/login';
              }
            },
            failureCallBack
          );
        }
      });

      window.updateProductCardsWishlist = function () {
        if (!$('body').hasClass('customer--logged-in')) return;
        $('[data-epi]').removeClass('active');
        WishlistSingle.addedProducts.forEach(function (product) {
          $(`[data-epi="${product.epi}"]`).addClass('active');
        });
        $('.wishlist-products [data-epi]:not(.active)')
          .closest('.product-card')
          .fadeOut('slow', function () {
            $(this).remove();
            if (WishlistSingle.addedProducts.length == 0) {
              $('.wishlist-heading__empty').fadeIn();
            }
          });
        $('.js-wishlist-count').toggleClass(
          'wishlist-badge--show',
          WishlistSingle.addedProducts.length > 0
        );
        $('.js-wishlist-count').text(WishlistSingle.addedProducts.length);
        $('body').toggleClass('has-wishlist-items', WishlistSingle.addedProducts.length > 0);
      };
    });

    if ($('.wishlist-products').length) {
      WishlistSingle.renderProducts();
    }
  }

  static renderProducts() {
    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(function (swat) {
      swat.fetch(function (products) {
        console.log({ products });
        if (products.length == 0) {
          $('.wishlist-heading__empty').fadeIn();
        }
        products.forEach(function (product, index) {
          var handle = product?.cprops?.handle;
          if (!handle) {
            console.error('WISHLIST: handle not provided in cprops.');
            swat.removeFromWishList(product);
            return;
          }
          var productUrl = `/products/${handle}?view=card`;
          fetch(productUrl)
            .then((response) => response.text())
            .then(function (responseText) {
              var $card = $(responseText.trim());
              $card.hide();
              $card.find('.js-wishlist__add').addClass('active');
              $card.css('order', index);
              $card.toggleClass('product-card--mobile-indent', index % 2 == 0);
              $card.find('[data-epi]').attr('data-epi', product?.epi);
              if ($card.hasClass('product-card')) {
                $('.wishlist-products').append($card);
              } else {
                swat.removeFromWishList(product);
              }
              $card.fadeIn('slow');
            });
        });
      });
    });
  }
}

window.WishlistSingle = WishlistSingle;
WishlistSingle.init();
